//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '@/api/api'

import firebase from 'firebase/app'
import 'firebase/storage'

export default {
    props: {
        restaurantToForm: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            logoFile: null,
            form: {
                restaurantName: '',
                email: '',
                phone: '',
                type: '',
                url: '',
                logo: '',
                // splashColor: '',
                // splashButtonColor: '',
                // menuBackgroundColor: '',
            },
            displayLoading: false,
            displayAlert: false,
            alertTitle: '',
            alertMessage: '',
            alertType: '',
            validEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            formStatusEdit: false,
            restID: '',
        }
    },
    methods: {
        clear() {
            this.form = {
                restaurantName: '',
                email: '',
                phone: '',
                url: '',
                logo: '',
                type: '',
                // splashColor: '',
                // splashButtonColor: '',
                // menuBackgroundColor: '',
            }

            this.logoFile = null
            this.formStatusEdit = false
            this.restID = ''
        },
        submitForm() {
            if (this.formStatusEdit) {
                this.updateRestaurant()
            } else {
                this.createNewRestaurant()
            }
        },
        async createNewRestaurant() {
            this.displayLoading = true
            let db = firebase.firestore()

            await this.uploadToFirebase(
                this.logoFile,
                `restaurants/${this.form.restaurantName}`,
                this.form.restaurantName
            ).then(async filename => {
                this.form.logo = filename
                api.createNewAdminRestaurant({Restaurant: this.form})
                    .then(response => {
                        this.displayLoading = false
                        this.alertTitle = 'Exito!'
                        this.alertMessage =
                            'Se ha creado el restaurante con exito'
                        this.alertType = 'success'
                        this.displayAlert = true
                        this.clear()
                    })
                    .catch(error => {
                        console.log(error)
                        this.displayLoading = false
                        this.alertTitle = 'Error'
                        this.alertMessage = error
                        this.alertType = 'error'
                        this.displayAlert = true
                    })
            })
        },
        async updateRestaurant() {
            this.displayLoading = true
            let db = firebase.firestore()

            if (this.logoFile != null) {
                await this.uploadToFirebase(
                    this.logoFile,
                    `restaurants/${this.form.restaurantName}`,
                    this.form.restaurantName
                ).then(async filename => {
                    this.form.logo = filename
                })
            }

            api.updateAdminRestaurantInfo({id: this.restID, Restaurant: this.form})
                .then(response => {
                        this.displayLoading = false
                        this.alertTitle = 'Exito!'
                        this.alertMessage =
                            'Se ha actualizado el restaurante con exito'
                        this.alertType = 'success'
                        this.displayAlert = true
                        this.clear()
                        this.$emit('restaurantUpdated')
                    })
                    .catch(error => {
                        console.log(error)
                        this.displayLoading = false
                        this.alertTitle = 'Error'
                        this.alertMessage = error
                        this.alertType = 'error'
                        this.displayAlert = true
                    })
        },
        uploadToFirebase(imageFile, fullDirectory, filename) {
            return new Promise(function (resolve, reject) {
                var storageRef = firebase
                    .storage()
                    .ref(fullDirectory + '/' + filename)
                //Upload file
                var task = storageRef.put(imageFile)
                //Update progress bar
                task.on(
                    'state_changed',
                    function (snapshot) {
                        // Observe state change events such as progress, pause, and resume
                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                        var progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100
                        console.log('Upload is ' + progress + '% done')
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused')
                                break
                        }
                    },
                    function (error) {
                        // Handle unsuccessful uploads
                        console.log(`Error in uploadToFirebase: ${error}`)
                        reject(error)
                    },
                    function () {
                        // Handle successful uploads on complete
                        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                        task.snapshot.ref
                            .getDownloadURL()
                            .then(function (downloadURL) {
                                console.log('File available at', downloadURL)
                                resolve(downloadURL)
                            })
                    }
                )
            })
        },
    },
    watch: {
        restaurantToForm(newValue, oldValue) {
            if (Object.keys(newValue).length > 0) {
                this.formStatusEdit = true
                this.restID = newValue.id
                this.form.restaurantName = newValue.restaurantName
                this.form.email = newValue.email
                this.form.phone = newValue.phone || "12345678" // Pepe: some test restaurants do not have phone number
                this.form.type = newValue.type
                this.form.url = newValue.url
                this.form.logo = newValue.logo // Pending: get logo file from firebase storage
            }
        }
    },
}
